import cls from './Sound.module.scss';
import soundOffImg from '../../assets/images/sound_off.svg';
import soundOnImg from '../../assets/images/sound_on.svg';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../redux/store';
import { toggleSound } from '../../redux/sound/slice';
import { Howl } from 'howler';
import buttonMp3 from '../../assets/sound/button_2.mp3';

const soundButton = new Howl({
  src: [buttonMp3],
});

const Sound = () => {
  const dispatch = useDispatch();
  const isSound = useSelector((state: RootState) => state.sound.isSound);
  return (
    <div className={cls.Sound}>
      <img
        alt="Sound off"
        src={isSound ? soundOnImg : soundOffImg}
        onClick={() => {
          soundButton.play();
          dispatch(toggleSound());
        }}
      />
    </div>
  );
};

export default Sound;
